import React, { useEffect, useState } from "react";
import { Table, Tag, Button } from "antd";
import CustomModal from "../../../../components/modal/CustomModal";
import { useToast } from "../../../../components/toast/toast";
import api from "../../../../api";

const LotteryModal = ({
  visible,
  onClose,
  setSelectedLottery,
  type = "active",
}) => {
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchData = async (page = 1, limit = pagination.pageSize) => {
    try {
      setLoading(true);
      const params = { page, limit };
      if (type === "active") {
        params.visibility = "public";
        params.status_in = ["upcoming", "ongoing", "drawing"];
      }

      const res = await api.get_lottery_list(params);
      if (res.status === 200) {
        setRows(res.data?.data || []);
        setPagination((p) => ({
          ...p,
          current: page,
          pageSize: limit,
          total: res.data?.pagination?.total || 0,
        }));
      } else {
        toast(res?.data?.message || "Алдаа гарлаа", "error");
      }
    } catch (e) {
      toast(e?.response?.data?.message || "Серверийн алдаа", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (visible) fetchData(1, pagination.pageSize);
  }, [visible, type]);

  const handleSelect = (record) => {
    setSelectedLottery?.(record);
    onClose?.();
  };

  const columns = [
    {
      title: "Гарчиг",
      dataIndex: "title",
      key: "title",
      render: (t, r) => (
        <div>
          <div style={{ fontWeight: 600 }}>{t}</div>
          <div style={{ fontSize: 12, opacity: 0.6 }}>{r.slug}</div>
        </div>
      ),
    },
    {
      title: "Код",
      dataIndex: "ticket_prefix",
      key: "ticket_prefix",
      width: 120,
    },
    {
      title: "Төлөв",
      dataIndex: "status",
      key: "status",
      width: 140,
      render: (s) => {
        const color =
          s === "ongoing"
            ? "green"
            : s === "drawing"
            ? "orange"
            : s === "completed"
            ? "red"
            : "default";
        return <Tag color={color}>{s}</Tag>;
      },
    },
    {
      title: "Үнэ",
      dataIndex: "ticket_price",
      key: "ticket_price",
      width: 120,
    },
    {
      title: "Үйлдэл",
      key: "action",
      width: 120,
      align: "center",
      render: (_, record) => (
        <Button
          type="link"
          style={{ fontSize: "12px" }}
          onClick={() => handleSelect(record)}
        >
          Сонгох
        </Button>
      ),
    },
  ];

  return (
    <CustomModal
      open={visible}
      title="Сугалаа сонгох"
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <Table
        rowKey="id"
        columns={columns}
        dataSource={rows}
        loading={loading}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          onChange: (page, pageSize) => fetchData(page, pageSize),
        }}
        size="middle"
      />
    </CustomModal>
  );
};

export default LotteryModal;
